export const DEPLOY_URL = 'https://assets.beta.qwykportals.com/portals-client/develop/';